import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-12bcbb80"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "align-content-center" }
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = { class: "grid mt-2 mx-2" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-4 md:col-12" }, " Tác giả ", -1 /* HOISTED */))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-4 md:col-12" }, " Tiêu đề ", -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      src: $setup.getImageUrl($props.image.id),
      alt: $props.image.caption,
      class: "image"
    }, null, 8 /* PROPS */, _hoisted_2),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createVNode(_component_InputText, {
        modelValue: $props.image.author,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($props.image.author) = $event)),
        class: "col-8 md:col-12"
      }, null, 8 /* PROPS */, ["modelValue"]),
      _hoisted_5,
      _createVNode(_component_InputText, {
        modelValue: $props.image.caption,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($props.image.caption) = $event)),
        class: "col-8 md:col-12"
      }, null, 8 /* PROPS */, ["modelValue"])
    ])
  ]))
}